module.exports = __webpack_public_path__ + "img/20-small.4ec05a1d.png";